module.exports = __webpack_public_path__ + "7666ad5100c5b47389a7847f76753883.svg";


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css-components-src/src/img/select-arrow.svg
// module id = 347
// module chunks = 1